module.exports = __webpack_public_path__ + "static/media/docs.ed150f13.svg";